/**
 * Tables whose changes reach the browser on the event stream, from
 * `db/migrations/005_change_notifications.sql` plus the two added since.
 *
 * The loader cache may only cache a response against tables in this list: a
 * table that never announces can never invalidate what it fed, so caching
 * against one shows stale data with no way out.
 *
 * Its own file, with no imports, so `test/cache-invalidation.test.ts` can check
 * it against the triggers actually in the database without dragging the browser
 * half of the client into a server test.
 */
export const NOTIFYING: ReadonlySet<string> = new Set([
  'clinics',
  'stores',
  'clinic_memberships',
  'store_memberships',
  'subscriptions',
  'clinic_settings',
  'store_settings',
  'treatments',
  'strengths',
  'supervisors',
  'cta_templates',
  'personas',
  'clinic_usage_periods',
  // JMC's shared starting material; the clinic screens read it live.
  'platform_defaults',
  'prompts',
  'prompt_versions',
  // The lint's own rules, since migration 095 made them editable.
  'prompt_checks',
  // The 文章チェック panel's own patterns, since migration 096 made them editable.
  'editorial_checks',
  'support_elevations',
  'articles',
  'article_reviews',
  'article_finding_dispositions',
  'article_sections',
  'clinic_prompt_styles',
  'clinic_prompt_requests',
  'clinic_prompt_choices',
  /*
   * Platform tables. Added with their triggers in migration 075: the operator
   * screens that read them re-fetched on every visit because there was nothing
   * to invalidate a cached copy, and legal_documents in particular changes from
   * the WORKER - a fetch job landing a new version is the one change no reader
   * could know to poll for.
   */
  'users',
  'legal_sources',
  'legal_documents',
  'corpus_releases',
]);
